// src/components/ServicesData.js

const servicesData = [
  {
    heading: 'Design',
    items: [
      { title: 'Architectural', slug: 'architectural' },
      { title: 'Civil & Site Engineering', slug: 'civil-site-engineering' },
      { title: 'Structural Engineering', slug: 'structural-engineering' },
      { title: 'Mechanical/Electrical/Plumbing', slug: 'mep-engineering' },
      { title: 'Water/Wastewater', slug: 'water-wastewater' },
      { title: 'Utilities Engineering', slug: 'utilities-engineering' },
    ],
  },
  {
    heading: 'Environmental & Sustainable Solutions',
    items: [
      { title: 'Permitting & NEPA', slug: 'permitting-nepa' },
      { title: 'LEED/Sustainable Designs', slug: 'leed-sustainable-designs' },
    ],
  },
  {
    heading: 'Management Services',
    items: [
      { title: 'Condition Assessment', slug: 'condition-assessment' },
      { title: 'Program Management', slug: 'program-management' },
      { title: 'Construction Management', slug: 'construction-management' },
    ],
  },
  {
    heading: 'Solid Waste',
    items: [
      { title: 'Leachate Treatment Plant', slug: 'leachate-treatment' },
      { title: 'Scale House', slug: 'scale-house' },
      { title: 'Recycle Facilities', slug: 'recycle-facilities' },
      { title: 'Flare Design', slug: 'flare-design' },
    ],
  },
  {
    heading: 'Secure Spaces',
    items: [
      {
        title:
          'ICD-705 Sensitive Compartmented Information Facility (SCIF)',
        slug: 'icd-705-scif',
      },
    ],
  },
];

export default servicesData;
